import type { ConsumptionAlertEventType } from '@octave/contracts';

export const consumptionAlertEventTypeMapping: Record<
  ConsumptionAlertEventType,
  string
> = {
  // Same three labels as the metric cards and the thresholds explainer: an
  // alert row and its counter must never be named differently.
  WARNING_EXCEEDED: 'Alerte 80 %',
  FAIR_USE_EXCEEDED: 'Alerte débit réduit',
  CUT_OFF_EXCEEDED: 'Alerte blocage',
  CARDINALITY_EXCEEDED: 'Limite de consommation atteinte',
  DATA_ROAMING_LOCKED: 'Alerte blocage, data en itinérance',
};

export type ConsumptionAlertSeverity = 'warning' | 'blocked';

export const consumptionAlertSeverity: Record<
  ConsumptionAlertEventType,
  ConsumptionAlertSeverity
> = {
  WARNING_EXCEEDED: 'warning',
  FAIR_USE_EXCEEDED: 'warning',
  CARDINALITY_EXCEEDED: 'warning',
  CUT_OFF_EXCEEDED: 'blocked',
  DATA_ROAMING_LOCKED: 'blocked',
};

/** Same pill style as the line-status tags in the lines list. */
export const consumptionAlertPillClasses: Record<
  ConsumptionAlertSeverity,
  string
> = {
  warning: 'bg-amber-50 text-amber-700 border-amber-200',
  blocked: 'bg-red-50 text-red-700 border-red-200',
};

export const consumptionAlertDotClasses: Record<
  ConsumptionAlertSeverity,
  string
> = {
  warning: 'bg-amber-500',
  blocked: 'bg-red-500',
};

/** Left icon of a row, coloured like the rest of the alert. */
export const consumptionAlertIconClasses: Record<
  ConsumptionAlertSeverity,
  { background: string; icon: string }
> = {
  warning: { background: 'bg-amber-50', icon: 'text-amber-600' },
  blocked: { background: 'bg-red-50', icon: 'text-red-600' },
};
